import { WARNING_MINIMUM_DPI } from '@/littleWedding/projectConstantes';
/**
 * Check if the image quality is good enough
 * @param params
 * @returns boolean - true if image is below 200dpi
 */
function imageQualityChecker(params: { dpiCheck: number; height: number; scaleX: number; scaleY: number; width: number }) {
    const { dpiCheck, height, scaleX, scaleY, width } = params;
    const qualityX = width / ((width * scaleX) / dpiCheck);
    const qualityY = height / ((height * scaleY) / dpiCheck);
    return qualityX < WARNING_MINIMUM_DPI || qualityY < WARNING_MINIMUM_DPI;
}

export { imageQualityChecker };
